<template>
  <v-card color="primary" dark height="280">
    <v-toolbar color="transparent" flat height="55">
      <v-toolbar-title class="subtitle-1 font-weight-medium">Cuentas por cobrar</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-tooltip right min-width="260" max-width="260" transition="scale-transition">
        <template v-slot:activator="{on}">
          <v-progress-linear v-on="on" background-color="orange lighten-4" color="deep-orange lighten-3" height="26" rounded :value="percentages.total_receivables_overdue" style="cursor:pointer;" />
        </template>
        <v-list light>
          <v-list-item class="px-0">
            <v-list-item-title><v-icon class="mt-n1" color="deep-orange lighten-3" left size="22">mdi-square-rounded</v-icon>Vencido</v-list-item-title>
            <v-list-item-subtitle class="text-right text--secondary">{{percentages.total_receivables_overdue}}%</v-list-item-subtitle>
          </v-list-item>
          <v-list-item class="px-0">
            <v-list-item-title><v-icon class="mt-n1" color="orange lighten-4" left size="22">mdi-square-rounded</v-icon>Por vencer</v-list-item-title>
            <v-list-item-subtitle class="text-right text--secondary">{{percentages.total_receivables_current_due}}%</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-tooltip>
    </v-card-text>
    <v-card-text class="white--text body-2 indigo darken-1">
      <v-skeleton-loader class="d-inline-block" v-if="loader" type="text" width="200" style="margin-top:6px;" />
      <template v-else><span class="body-1">{{datasets.total_receivables_overdue.value | currency(account.base_currency.id)}}</span> <span class="body-2">{{account.base_currency.id}} vencido</span></template>
    </v-card-text>
    <v-card-text class="white--text body-2 indigo darken-2">
      <v-skeleton-loader class="d-inline-block" v-if="loader" type="text" width="200" style="margin-top:6px;" />
      <template v-else><span class="body-1">{{datasets.total_receivables_current_due.value | currency(account.base_currency.id)}}</span> <span class="body-2">{{account.base_currency.id}} por vencer</span></template>
    </v-card-text>
    <v-card-text class="white--text indigo darken-3">
      <v-skeleton-loader class="d-inline-block" v-if="loader" type="text" width="200" style="margin-top:6px;" />
      <template v-else><span class="body-1 font-weight-medium">{{datasets.total_receivables.value | currency(account.base_currency.id)}}</span> <span class="body-2">{{account.base_currency.id}} total por cobrar</span></template>
    </v-card-text>
  </v-card>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    datasets: {
      total_receivables_current_due: {},
      total_receivables_overdue: {},
      total_receivables: {}
    },
    loader: false,
    percentages: {
      total_receivables_current_due: 0,
      total_receivables_overdue: 0
    }
  }),
  created () {
    this.loader = true

    Promise.all([
      this.retrieveMetric('total_receivables_current_due'),
      this.retrieveMetric('total_receivables_overdue'),
      this.retrieveMetric('total_receivables')
    ])
    .then(() => {
      Object.keys(this.percentages).forEach(key => {
        const dataset = this.datasets[key]

        if (dataset.value && dataset.value > 0) {
          this.percentages[key] = ((dataset.value / this.datasets.total_receivables.value) * 100).toFixed(2)
        }
      })
    })
    .finally(() => {
      setTimeout(() => {
        this.loader = false
      }, 800)
    })
  },
  methods: {
    async retrieveMetric (name) {
      const dataset = await this.$store.dispatch('analytics/GET', {
        resource: `metrics/${name}/kpi`,
        query: {
          interval: 'monthly',
          comparative: 'this_v_last_mtd'
        }
      })

      this.datasets[name] = dataset.data
    }
  }
}
</script>
